<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Province Cities</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <button class="btn btn-white vertical align-items-center" (click)="import()">
          <input type="file" name="file" class="custom-file-input" id="importProvinceCities" required (change)="handleProvinceCitiesImport($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden>
          Importare<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="downloadCsvFormat()">
          Scarica il formato CSV
        </button>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper">
        <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
            <form class="table-row-container row first-row filter" [formGroup]="provinceCitiesFilterForm" (ngSubmit)="filter()" *ngIf="provinceCitiesFilterForm">
                <div class="item data-col-10 hideOnPhoneView">
                    <h4 class="title" (click)="navigateOrder('Provinces.id')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.id')"></i>
                      ID
                    </h4>
                    <span class="data">
                      <input type="number" formControlName="Provinces.id" min="1000" max="10000" >
                    </span>
                </div>
          
                <div class="item data-col-20 hideOnPhoneView">
                    <h4 class="title" (click)="navigateOrder('Provinces.province')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.province')"></i>
                      Province
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="Provinces.province" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                    </span>
                </div>

                <div class="item data-col-20 hideOnPhoneView">
                    <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
                      <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
                      Province Code
                    </h4>
                    <span class="data">
                      <input type="text" formControlName="Provinces.provinceCode" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                    </span>
                </div>

                <div class="item data-col-20 hideOnPhoneView">
                  <h4 class="title" (click)="navigateOrder('Provinces.provinceCities.count')">
                    <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCities.count')"></i>
                    No Of Cities
                  </h4>
                  <span class="data">
                    <input type="text" formControlName="Provinces.provinceCities.count" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                  </span>
                </div>

                <div class="item data-col-5 hideOnPhoneView">
                    <h4 class="title">Azioni</h4>
                    <span class="data saifu">
                      <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
                        <i class="fas fa-search"></i>
                      </button>
                      <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
                        <i class="fas fa-undo"></i>
                      </button>
                    </span>
                </div>
                <hr class="hr-clear">
            </form>

            <div class="table-row-container row" *ngFor="let province of provinceCities">

                <div class="item data-col-10">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      ID
                    </h4>
                    <div class="data data-id">
                      <div>{{ province?.id || "---" }}</div>
                    </div>
                </div>

                <div class="item data-col-10">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Province
                    </h4>
                    <div class="data">
                      <div>{{ province?.province || "---" }}</div>
                    </div>
                </div>
            
                <div class="item data-col-10">
                    <h4 class="title">
                      <i class="sort-icon fas"></i>
                      Province Code
                    </h4>
                    <div class="data">
                      <div>{{ province?.provinceCode || "---" }}</div>
                    </div>
                </div>

                <div class="item data-col-10">
                  <h4 class="title">
                    <i class="sort-icon fas"></i>
                    No Of Cities
                  </h4>
                  <div class="data">
                    <div><a (click)="showCities(province)" href="javascript:void(0)">{{ province?.provinceCities.length || "0" }}</a></div>
                  </div>
                </div>

                <div class="item data-col-5">
                    <h4 class="title"></h4>
                    <span class="data saifu">
                      <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top" [routerLink]="['/provinces/cities/edit', province?.id]">MODIFICA</button>
                    </span>
                </div>
            </div>
        </div>
    </section>

  </div>
</section>


<!--
<section class="title-bar content-padding first-item">

  <div class="wrapper nowrap">
    <h2 class="title-heading">Province Cities</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">

        <button class="btn btn-white full-width-btn vertical align-items-center" (click)="import()">
          <input type="file" name="file" class="custom-file-input" id="importProvinceCities" required (change)="handleProvinceCitiesImport($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden>
          Importare<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn vertical full-width-btn align-items-center" (click)="downloadCsvFormat()">
          Scarica il formato CSV
        </button>

      </span>
    </div>
  </div>
</section>
<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="provinceCitiesFilterForm" (ngSubmit)="filter()" *ngIf="provinceCitiesFilterForm">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Provinces.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" formControlName="Provinces.id" min="1000" max="10000" >
                </span>
            </div>
      
            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Provinces.province')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.province')"></i>
                  Province
                </h4>
                <span class="data">
                  <input type="text" formControlName="Provinces.province" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
                  Province Code
                </h4>
                <span class="data">
                  <input type="text" formControlName="Provinces.provinceCode" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('Provinces.provinceCities.count')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCities.count')"></i>
                No Of Cities
              </h4>
              <span class="data">
                <input type="text" formControlName="Provinces.provinceCities.count" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-5 hideOnPhoneView">
                <h4 class="title">Azioni</h4>
                <span class="data saifu">
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); filter()">
                    <i class="fas fa-search"></i>
                  </button>
                  <button class="btn hvr-grow" (click)="$event.preventDefault(); resetFilter()">
                    <i class="fas fa-undo"></i>
                  </button>
                </span>
            </div>
            <hr class="hr-clear">
        </form>

        <div class="table-row-container row" *ngFor="let province of provinceCities">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ province?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Province
                </h4>
                <div class="data">
                  <div>{{ province?.province || "---" }}</div>
                </div>
            </div>
        
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Province Code
                </h4>
                <div class="data">
                  <div>{{ province?.provinceCode || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
              <h4 class="title">
                <i class="sort-icon fas"></i>
                No Of Cities
              </h4>
              <div class="data">
                <div><a (click)="showCities(province)" href="javascript:void(0)">{{ province?.provinceCities.length || "0" }}</a></div>
              </div>
            </div>

            <div class="item data-col-5">
                <h4 class="title"></h4>
                <span class="data saifu">
                  <button class="btn hvr-grow has-margin-right has-margin-bottom has-margin-right has-margin-top" [routerLink]="['/provinces/cities/edit', province?.id]">MODIFICA</button>
                </span>
            </div>
        </div>
    </div>
</section>
-->

